export default "__VITE_ASSET__DJq2PXUP__"